import { devLog, devWarn, devError } from '../utils/devLogger';

// 카카오 SDK 초기화 및 유틸리티 함수
declare global {
  interface Window {
    Kakao: any;
  }
}

// 카카오 SDK 초기화
export const initKakaoSDK = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    if (!window.Kakao) {
      devWarn('카카오 SDK가 아직 로드되지 않았습니다.');
      return false;
    }

    const appKey = process.env.REACT_APP_KAKAO_APP_KEY;
    if (!appKey) {
      devError('REACT_APP_KAKAO_APP_KEY가 설정되지 않았습니다.');
      return false;
    }
    
    if (!window.Kakao.isInitialized()) {
      window.Kakao.init(appKey);
      devLog('카카오 SDK 초기화 완료');
    }
    return true;
  } catch (error) {
    devError('카카오 SDK 초기화 실패:', error);
    return false;
  }
};

// 카카오 로그인
export const kakaoLogin = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    try {
      if (!window.Kakao?.Auth) {
        reject(new Error('카카오 SDK가 로드되지 않았습니다.'));
        return;
      }

      window.Kakao.Auth.login({
        success: (response: any) => {
          devLog('카카오 로그인 성공:', response);
          // 사용자 정보 가져오기
          window.Kakao.API.request({
            url: '/v2/user/me',
            success: (userInfo: any) => {
              devLog('카카오 사용자 정보:', userInfo);
              resolve({
                accessToken: response.access_token,
                userInfo: userInfo,
                providerId: userInfo.id.toString()
              });
            },
            fail: (error: any) => {
              devError('카카오 사용자 정보 조회 실패:', error);
              reject(error);
            }
          });
        },
        fail: (error: any) => {
          devError('카카오 로그인 실패:', error);
          reject(error);
        }
      });
    } catch (error) {
      devError('카카오 로그인 실행 중 오류:', error);
      reject(error);
    }
  });
};

// 카카오 로그아웃
export const kakaoLogout = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!window.Kakao?.Auth) {
      reject(new Error('카카오 SDK가 로드되지 않았습니다.'));
      return;
    }

    window.Kakao.Auth.logout(() => {
      devLog('카카오 로그아웃 완료');
      resolve();
    });
  });
};
